export const pluralize = (count, single, plural234, other) => {
  const lastDigit = count % 10;
  if (lastDigit === 1) return single;
  if (lastDigit >= 2 && lastDigit <= 4) return plural234;
  return other;
};
